export var SnapshotState;
(function (SnapshotState) {
    SnapshotState[SnapshotState["INVALID"] = 0] = "INVALID";
    SnapshotState[SnapshotState["VALID"] = 1] = "VALID";
    SnapshotState[SnapshotState["DELETING"] = 2] = "DELETING";
    SnapshotState[SnapshotState["DELETED"] = 3] = "DELETED";
})(SnapshotState || (SnapshotState = {}));
